import { render, staticRenderFns } from "./ThreeChild.vue?vue&type=template&id=5ade56a3&scoped=true"
import script from "./ThreeChild.vue?vue&type=script&lang=js"
export * from "./ThreeChild.vue?vue&type=script&lang=js"
import style0 from "./ThreeChild.vue?vue&type=style&index=0&id=5ade56a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ade56a3",
  null
  
)

export default component.exports